import { z } from '../utils/zod.js';
import { adminPageResponse, adminPaginationQuerySchema } from './pagination.js';
export const adminListAuditLogsQuerySchema = adminPaginationQuerySchema.extend({
    entityType: z.string().trim().min(1).max(100).optional(),
    entityId: z.string().trim().min(1).max(255).optional(),
    userId: z.string().uuid().optional(),
    userType: z.string().trim().min(1).max(50).optional(),
    action: z.string().trim().min(1).max(100).optional(),
    from: z.string().datetime({ offset: true }).optional(),
    to: z.string().datetime({ offset: true }).optional(),
});
export const ADMIN_ACTOR_KINDS = ['staff', 'user', 'signer', 'system'];
export const adminActorKindSchema = z.enum(ADMIN_ACTOR_KINDS);
// name/email are only resolved for staff and users; signers and system rows carry the id alone.
export const adminActorSchema = z.object({
    kind: adminActorKindSchema,
    id: z.string().uuid().nullable(),
    name: z.string().optional(),
    email: z.string().optional(),
});
export const adminAuditLogDtoSchema = z.object({
    id: z.string().uuid(),
    createdAt: z.string().datetime(),
    userId: z.string().uuid().nullable(),
    userType: z.string().nullable(),
    requestId: z.string().nullable(),
    ipAddress: z.string().nullable(),
    entityType: z.string(),
    entityId: z.string().nullable(),
    action: z.string(),
    payload: z.unknown().nullable(),
    context: z.unknown().nullable(),
    actor: adminActorSchema,
    entityLabel: z.string().nullable().openapi({ description: 'Name, email or signing name of the entity' }),
});
export const adminListAuditLogsResponseSchema = adminPageResponse(adminAuditLogDtoSchema);
